export const fetchTokens = async (
    domain: string,
    clientId: string,
    redirectUri: string,
    code: string) => {

    const data = new URLSearchParams();
    data.append('grant_type', 'authorization_code');
    data.append('client_id', clientId);
    data.append('code', code);
    data.append('redirect_uri', redirectUri);

    const response = await fetch(`${domain}/oauth2/token`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
    });

    if (!response.ok) 
    {
        throw new Error('Failed to exchange token');
    }
    
    return await response.json();
}